module.exports = __webpack_public_path__ + "img/figure2.fe3d8b13.png";